import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {RouteDataService} from "../../services/route-data/route-data.service";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-mobile-page-title',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ds-mobile-page-title.component.html',
    styleUrls: ['./ds-mobile-page-title.component.scss'],
    standalone: false
})
export class DsMobilePageTitleComponent implements OnInit {

  public title: string;
  @Input() noPadding?: boolean = false;

  private hiddenPaths: string[] = ['website', 'hosting', 'builder', 'themes', 'installed-plugins',
    'change-environment', 'change-environment-dev', 'change-environment-live'];
  constructor(
    private _routeDataService: RouteDataService,
  ) {

  }

  ngOnInit() {
    this.getTitle();
  }

  private getTitle(): void {
    const data = this._routeDataService.getRouteDatas();
    this.title = data.reduce((result: string, route): string => {
      if (!this.hiddenPaths.includes(route.pageId)) {
        return route.title;
      }
      return result;
    }, null);
  }
}
